import { ActionType, PayloadErrorType } from 'types/reduxTypes';
import { SubscriberType } from 'types/stateTypes';
import {
  CLEAR_FOLLOWERS,
  CLEAR_FOLLOWINGS,
  DELETE_FOLLOWER,
  DELETE_FOLLOWER_FAILED,
  DELETE_FOLLOWER_SUCCESS,
  GET_FOLLOWERS,
  GET_FOLLOWERS_FAILED,
  GET_FOLLOWERS_SUCCESS,
  GET_FOLLOWINGS,
  GET_FOLLOWINGS_FAILED,
  GET_FOLLOWINGS_SUCCESS,
  SUBSCRIBE,
  SUBSCRIBE_FAILED,
  SUBSCRIBE_SUCCESS,
} from '../constants';

export type GetFollowersType = {
  userId: string;
  page?: number;
  pageSize?: number;
};

export type GetFollowersPayload = {
  items: SubscriberType[];
  pageSize: number;
  page: number;
};

export type SubscribePayloadType = {
  userId: string;
  subscribed: boolean;
  blocked?: boolean;
  fullName?: string;
  imageUrl?: string;
  isForeignProfile?: boolean;
};

export function subscribe(payload: SubscribePayloadType): ActionType {
  return {
    payload,
    type: SUBSCRIBE,
  };
}

export function subscribeSuccess(payload: SubscribePayloadType): ActionType {
  return {
    payload,
    type: SUBSCRIBE_SUCCESS,
  };
}

export function getFollowings(payload: GetFollowersType): ActionType {
  return {
    payload,
    type: GET_FOLLOWINGS,
  };
}

export function getFollowingsSuccess(payload: GetFollowersPayload): ActionType {
  return {
    payload,
    type: GET_FOLLOWINGS_SUCCESS,
  };
}

export function getFollowingsFailed(payload: PayloadErrorType): ActionType {
  return {
    payload,
    type: GET_FOLLOWINGS_FAILED,
  };
}

export function clearFollowings(payload: unknown): ActionType {
  return {
    payload,
    type: CLEAR_FOLLOWINGS,
  };
}

export function getFollowers(payload: GetFollowersType): ActionType {
  return {
    payload,
    type: GET_FOLLOWERS,
  };
}

export function getFollowersSuccess(payload: GetFollowersPayload): ActionType {
  return {
    payload,
    type: GET_FOLLOWERS_SUCCESS,
  };
}

export function getFollowersFailed(payload: PayloadErrorType): ActionType {
  return {
    payload,
    type: GET_FOLLOWERS_FAILED,
  };
}

export function clearFollowers(payload: unknown): ActionType {
  return {
    payload,
    type: CLEAR_FOLLOWERS,
  };
}

export function subscribeFailed(payload: PayloadErrorType): ActionType {
  return {
    payload,
    type: SUBSCRIBE_FAILED,
  };
}

export function deleteFollower(payload: SubscribePayloadType): ActionType {
  return {
    payload,
    type: DELETE_FOLLOWER,
  };
}

export function deleteFollowerSuccess(payload: SubscribePayloadType): ActionType {
  return {
    payload,
    type: DELETE_FOLLOWER_SUCCESS,
  };
}

export function deleteFollowerFailed(payload: PayloadErrorType): ActionType {
  return {
    payload,
    type: DELETE_FOLLOWER_FAILED,
  };
}
